export default __webpack_public_path__ + "static/Rabbit Logo-f63a70ca2b160afaecde7d016fa73ef4.png";